








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class AddItemButtons extends Vue {
  @Prop(String) public listId!: string;
  @Prop(String) public next: string;

  public addItem(mode: string) {
    this.$router.push({
      name: 'AddItem',
      params: { listId: this.listId, next: this.next, mode }
    });
  }
}
